import { render, staticRenderFns } from "./RegisterViewPad.vue?vue&type=template&id=129a0fab&scoped=true"
import script from "./RegisterViewPad.vue?vue&type=script&lang=js"
export * from "./RegisterViewPad.vue?vue&type=script&lang=js"
import style0 from "./RegisterViewPad.vue?vue&type=style&index=0&id=129a0fab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a0fab",
  null
  
)

export default component.exports